import { Grid, Skeleton } from "@mui/material";

const LoadingScreen = () => {
  return (
    <Grid container sx={{ p: 2 }}>
      <Grid item container xs={12}>
        <Grid item xs={12} md={12} lg={8} container>
          <Grid item xs={8}>
            <Skeleton height="80px" />
          </Grid>
          <Grid item container xs={12}>
            <Grid item xs={4}>
              <Skeleton height="80px" />
            </Grid>
          </Grid>
          <Grid item container xs={12} columnSpacing={1}>
            <Grid item xs={4}>
              <Skeleton height="80px" />
            </Grid>
            <Grid item xs={4}>
              <Skeleton height="80px" />
            </Grid>
            <Grid item xs={4}>
              <Skeleton height="80px" />
            </Grid>
          </Grid>
          <Grid item container xs={12} columnSpacing={1}>
            <Grid item xs={4}>
              <Skeleton height="80px" />
            </Grid>
            <Grid item xs={4}>
              <Skeleton height="80px" />
            </Grid>
            <Grid item xs={4}>
              <Skeleton height="80px" />
            </Grid>
          </Grid>
          <Grid item container xs={12} columnSpacing={1}>
            <Grid item xs={4}>
              <Skeleton height="80px" />
            </Grid>
            <Grid item xs={4}>
              <Skeleton height="80px" />
            </Grid>
            <Grid item xs={4}>
              <Skeleton height="80px" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LoadingScreen;
